/**
 * Transient top-of-viewport notice (toast-style).
 * Backoffice offsets — compact layout without storefront header.
 */

/** Distance from viewport top to the resting top edge of the toast panel — desktop */
export const SITE_TOAST_TOP_OFFSET_DESKTOP_PX = 24

/** Same as above — compact viewports */
export const SITE_TOAST_TOP_OFFSET_MOBILE_PX = 16

/** How long the message stays readable after slide-in completes */
export const SITE_TOAST_VISIBLE_DURATION_MS = 3000

/** Enter / exit motion length (applied to transform + opacity) */
export const SITE_TOAST_TRANSITION_MS = 380

export const SITE_TOAST_MOBILE_BREAKPOINT_PX = 576
